import config from '../configurations/config'
export const authenticatedUser = () => {
    return fetch(`${config.auth.URL}user`, {
        credentials: 'include' // fetch won't send cookies unless you set credentials
    }).then(user => {
        return user.json();
    }).catch(err => {
        console.log("Error while fetching the user object ...", err);
        return {};
    });    
}

export const token = () => {
    return fetch(`${config.auth.URL}token`, {
       credentials: 'include' // fetch won't send cookies unless you set credentials
    }).then(token => {
        return token.json();
    }).catch(err => {
        console.log("Error while fetching the token ...", err);
        return {};
    });
}  
export const adminlogout = () => {
    return fetch(`${config.auth.URL}logout`, {
        credentials: 'include' // fetch won't send cookies unless you set credentials
    });   
}